function Compare() {
  return <p>Compare</p>;
}

export default Compare;
